/**
 * Loading Screen Component
 *
 * Displays a loading screen while the application initializes.
 */

import React from 'react';
import './LoadingScreen.css';

interface LoadingScreenProps {
    status?: string;
    fadeOut?: boolean;
}

export const LoadingScreen: React.FC<LoadingScreenProps> = ({
    status: _status = 'システム初期化中...',
    fadeOut = false
}) => {
    return (
        <div className={`loading-screen ${fadeOut ? 'fade-out' : ''}`}>
            <div className="loading-spinner" />
        </div>
    );
};

export default LoadingScreen;
